export const InitialUrlData = {
  payload: {
    url: "",
    name: "",
  },
};
